module.exports = __webpack_public_path__ + "img/kosiara.33fd15c0.jpg";